<main class="container-bg">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <h2 class="m-b-30">Agregar Usuarios</h2>
    <section class="container-form">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Nombre </mat-label>
        <input matInput formControlName="firstName" />
        <mat-hint
          *ngIf="f['firstName'].touched && f['firstName'].invalid"
          class="m-b-16 error-msg"
        >
          <div
            class="text-error"
            *ngIf="f['firstName'].errors && f['firstName'].errors['required']"
          >
            Este Campo es requerido
          </div>
          <div
            class="text-error"
            *ngIf="f['firstName'].errors && f['firstName'].errors['minlength']"
          >
            Debe tener un minimo de 6 caracteres
          </div>
        </mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Apellido </mat-label>
        <input matInput formControlName="lastName" />
        <mat-hint
          *ngIf="f['lastName'].touched && f['lastName'].invalid"
          class="m-b-16 error-msg"
        >
          <div
            class="text-error"
            *ngIf="f['lastName'].errors && f['lastName'].errors['required']"
          >
            Este Campo es requerido
          </div>
          <div
            class="text-error"
            *ngIf="f['lastName'].errors && f['lastName'].errors['minlength']"
          >
            Debe tener un minimo de 6 caracteres
          </div>
        </mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Numero </mat-label>
        <input matInput formControlName="phone" type="number" />
        <mat-hint
          *ngIf="f['phone'].touched && f['phone'].invalid"
          class="m-b-16 error-msg"
        >
          <div
            class="text-error"
            *ngIf="f['phone'].errors && f['phone'].errors['required']"
          >
            Este Campo es requerido
          </div>
          <div
            class="text-error"
            *ngIf="f['phone'].errors && f['phone'].errors['minlength']"
          >
            Debe tener un minimo de 6 caracteres
          </div>
        </mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>RUT</mat-label>
        <input matInput formControlName="rut" (blur)="inputRut()" />
        <mat-hint
          *ngIf="f['rut'].touched && f['rut'].invalid"
          class="m-b-16 error-msg"
        >
          <div
            class="text-error"
            *ngIf="f['rut'].errors && f['rut'].errors['required']"
          >
            Este Campo es requerido
          </div>
        </mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" />
        <mat-hint
          *ngIf="f['email'].touched && f['email'].invalid"
          class="m-b-16 error-msg"
        >
          <div
            class="text-error"
            *ngIf="f['email'].errors && f['email'].errors['required']"
          >
            Este Campo es requerido
          </div>
        </mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Rol / Roles</mat-label>
        <mat-select formControlName="roles">
          <mat-option value="ejecutivo"> Ejecutivo </mat-option>
          <mat-option value="admin"> Administrador </mat-option>
          <mat-option value="Jefe"> Jefe </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100" color="primary">
        <mat-label>Contraseña</mat-label>
        <input
          matInput
          [type]="hide ? 'password' : 'text'"
          formControlName="password"
        />
        <span
          style="
            border: 0px;
            background: transparent;
            cursor: pointer;
            padding-right: 5px;
          "
          matSuffix
          (click)="hide = !hide"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide"
        >
          <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
        </span>
        <mat-hint
          *ngIf="f['password'].touched && f['password'].invalid"
          class="m-b-16 error-msg"
        >
          <div
            class="text-error"
            *ngIf="f['password'].errors && f['password'].errors['required']"
          >
            Este Campo es Requerido
          </div>
        </mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100" color="primary">
        <mat-label>Repita Contraseña</mat-label>
        <input
          matInput
          [type]="hide ? 'password' : 'text'"
          formControlName="confirmPassword"
        />
        <span
          style="
            border: 0px;
            background: transparent;
            cursor: pointer;
            padding-right: 5px;
          "
          matSuffix
          (click)="hide = !hide"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide"
        >
          <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
        </span>
        <mat-hint
          *ngIf="f['confirmPassword'].touched && f['confirmPassword'].invalid"
          class="m-b-16 error-msg"
        >
          <div
            class="text-error"
            *ngIf="
              f['confirmPassword'].errors &&
              f['confirmPassword'].errors['required']
            "
          >
            Este Campo es Requerido
          </div>
          <div
            *ngIf="
              f['confirmPassword'].hasError('mismatch') &&
              f['confirmPassword'].touched
            "
            class="text-error"
          >
            Las contraseñas no coinciden.
          </div>
        </mat-hint>
      </mat-form-field>
    </section>
    <div class="mat-spinner" **ngIf="!showSpinner">
      <mat-spinner></mat-spinner>
    </div>
    <button
      mat-flat-button
      color="primary"
      class="w-50"
      [disabled]="!form.valid"
    >
      Registrate
    </button>
  </form>
</main>
